import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { useLocation } from "react-router-dom";


function SplashScreenSuccess() {

    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;

    const navigate = useNavigate();

    const uselocation = useLocation();
    const [location, SetLocation] = useState((uselocation) ? uselocation : {});
    let myTimeout;
    useEffect(() => {
        myTimeout = setTimeout(function () {
            if (location.state) {
                navigate(location.state.path);
            } else {
                navigate('/');
            }

        }, 1500);

    }, []);



    function myStopFunction() {
        clearTimeout(myTimeout);
    }
    return (
        <Box>
            <Container component="main" maxWidth="xs"  >
                <Grid container spacing={2} sx={{ mt: 20 }}  >
                    {location.state && <Grid item xs={12} sm={12}>
                        <Typography variant="h4" align="center" color={appThemeColor}>{location.state.header}</Typography>
                    </Grid>}
                    {location.state && <Grid item xs={12} sm={12}>
                        <Typography variant="h6" align="center" >{location.state.body}</Typography>
                    </Grid>}
                    {location.state && location.state.subtitle && <Grid item xs={12} sm={12}>
                        <Typography variant="body2" align="center" >{location.state.subtitle}</Typography>
                    </Grid>}
                </Grid>
            </Container>
        </Box>
    )
}

export default SplashScreenSuccess